var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mini-node",style:({
    width: _vm.settings.width,
    height: _vm.settings.height,
    transform: 'translate('+_vm.settings.x+'px, '+_vm.settings.y+'px)',
    background: _vm.nodeColor
  })})}
var staticRenderFns = []

export { render, staticRenderFns }